<template>
  <div class="invoice-item">
    <div @click="todo(findButton(cardClickType).method, invoice)">
      <van-row :class="['context-wrap', btnList.length === 0 ? 'context-wrap-noborder' : ''].join(' ')">
        <van-col span="24" :class="['customer-name', showFullPurchaserName ? 'customer-name-full' : '']">
          <span :class="['title', showFullPurchaserName ? 'title-full' : '']" v-if="invoice.purchaserName || invoice.settlementSource !== 7">单位名称：{{invoice.purchaserName}}</span>
          <span class="title" v-else></span>
          <span :class="`invoice-cube ${ invoice.invoiceType == 7 || invoice.invoiceType == 8 ? 'invoice-big-cude' : ''}`">{{renderInvoiceType(invoice.invoiceType)}}</span>
        </van-col>
        <van-col span="24" class="customer-name" v-if="showInvoiceNo">发票号码：{{invoice.invoiceNo || ''}}</van-col>
        <van-col span="24" class="customer-name">开票金额：{{convertNumber(invoice.amountWithTax)}}</van-col>
        <van-col span="24" class="customer-name">开票税额：{{convertNumber(invoice.taxAmount)}}</van-col>
        <van-col span="24" class="invoice-time" v-if="invoice.drewDate">开票时间：{{invoice.drewDate ? invoice.drewDate.split(' ')[0]: ''}}</van-col>
      </van-row>
      <van-row :class="['btn-wrap', showFullPurchaserName ? 'btn-wrap-flexible' : '']" v-if="btnList.length">
        <van-button
          plain
          type="primary"
          size="normal"
          round
          v-for="(btn, index) in btnList"
          :key="index"
          :disabled="isButtonDisabled(btn)"
          v-on:click.stop="todo(findButton(btn).method, invoice)"
          :color="findButton(btn).color"
          :class="['btn-item', renderClass(btn), isButtonDisabled(btn) ? 'btn-item-disabled' : ''].join(' ')"
        >
          {{findButton(btn).name}}
        </van-button>
      </van-row>
      <img
        :class="['invoice-tag', showFullPurchaserName ? 'invoice-tag-above-actions' : '']"
        :src="getConfig(invoice).url"
        v-if="getConfig(invoice).url"
      />
    </div>
    <van-overlay v-if="invoiceVisible" :show="invoiceVisible" @click="invoiceVisible = false">
      <div class="modal-wrapper" @click="invoiceVisible = false">
        <InvoiceImagePreview v-if="invoiceVisible" :invoiceData="detailData" />
      </div>
    </van-overlay>
    <van-overlay v-if="settlementInvoiceVisible" :show="settlementInvoiceVisible" @click="settlementInvoiceVisible = false">
      <div class="modal-wrapper" @click="settlementInvoiceVisible = false">
        <InvoiceSwiper :invoiceList="invoiceList"/>
      </div>
    </van-overlay>
     <div class="pop-picker-container">
      <van-popup v-model="popupVisible" get-container=".pop-picker-container">
        <div class="pop-inner">
          <p class="title">申请原因</p>
          <div >
            <InputField
              type="textarea"
              :value="modalParams.applyMsg"
              placeholder="请输入申请原因"
              @oninputchange="($event) => onInputChange({e: $event, field:'applyMsg'})"
            />
            <div class="submit-btn-wrp">
              <van-button
                loading-type="spinner"
                class="submit-btn"
                type="info"
                @click="popupVisible = false"
                >取消
              </van-button>
              <van-button
                loading-type="spinner"
                class="submit-btn"
                type="info"
                @click="modalClick('applyRed')"
                v-if="canRed()"
                >申请红冲
              </van-button>
              <van-button
                loading-type="spinner"
                class="submit-btn"
                type="info"
                @click="modalClick('applyCancel')"
                v-if="cancel()"
                >申请作废
              </van-button>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Button,
  Notify,
  Toast,
  Overlay,
  Popup
} from 'vant'

import InvoiceImagePreview from '../InvoiceImagePreview'
import InvoiceSwiper from '../InvoiceSwiper'
import InputField from '@components/InputField'

import {
  renderTextWithConfig,
  getConfigWithText,
  onCount,
  ConvertNumber
} from '@utils/basicUtil'

import {
  STAT_INVOICE_STATUS,
  APPLY_INVOICE_STATUS,
  INVOICE_METHOD,
  INVOICE_TYPE_FOR_CARD,
  GET_TYPE,
  INVOICE_TYPE_FOR_CARD_INCOME,
  INVOICE_STATUS_ICON
} from '@assets/config'
import { invoiceRequest } from '@services'

const BATCH_IMPORT_SETTLEMENT_SOURCE = 14

const invoiceCardButtonType = [
  {
    name: '编 辑',
    method: 'edit',
    color: '#4573DE'
  },
  {
    name: '重 开',
    method: 'retry',
    color: '#4573DE'
  },
  {
    name: '删 除',
    method: 'delete',
    color: '#666666'
  },
  {
    name: '预 览',
    method: 'settlementInvoicePreview',
    color: '#4573DE'
  },
  {
    name: '发票预览',
    method: 'preview',
    color: '#4573DE'
  },
  {
    name: '查看详情',
    method: 'detail',
    color: '#4573DE'
  },
  {
    name: '查看详情', // 从申请列表卡片上点进去
    method: 'applyDetail',
    color: '#4573DE'
  },
  {
    name: '查看详情', // 电票直开查看详情
    method: 'customApplyDetail',
    color: '#4573DE'
  },
  {
    name: '下载版式文件',
    method: 'downloadLayout',
    color: '#4573DE'
  },
  {
    name: '物流跟踪',
    method: 'express',
    color: '#666666'
  },
  {
    name: '更 多',
    method: 'more',
    color: '#666666'
  },
  {
    name: '',
    method: 'none',
    color: '#666666'
  }
]

export default {
  props: {
    withGetType: {
      type: Boolean,
      default: true
    },
    invoice: {
      type: Object
    },
    btnList: {
      type: Array
    },
    disabledBtnList: {
      type: Array,
      default: () => []
    },
    type: {
      type: String
    },
    cardClickType: {
      type: String,
      default: 'none'
    },
    incomeJump: {
      type: Function
    },
    showFullPurchaserName: {
      type: Boolean,
      default: false
    },
    showInvoiceNo: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    files: [],
    receiverInfo: {},
    invoiceVisible: false,
    settlementInvoiceVisible: false,
    detailData: {},
    invoiceList: [],
    modalParams: {
      applyMsg: ''
    },
    popupVisible: false
  }),
  mounted () {
  },
  methods: {
    convertNumber (num) {
      return ConvertNumber(num)
    },
    incomeItemJump () {
      this.$emit('incomeJump')
    },
    renderStatus (text) {
      if (this.type === 'apply') {
        return renderTextWithConfig(text, APPLY_INVOICE_STATUS)
      } else {
        return renderTextWithConfig(text, STAT_INVOICE_STATUS)
      }
    },
    renderStatusColor () {
      let status = ''
      if (this.type === 'apply') {
        status = this.invoice.status
        return (status === 0 || status === 1) ? '#BFBFBF' : '#EC547A'
      } else {
        status = this.invoice.invoiceStatus
        const colorFromConfig = getConfigWithText(status, STAT_INVOICE_STATUS) ? getConfigWithText(status, STAT_INVOICE_STATUS).color : null
        return colorFromConfig
      }
    },
    renderDate () {
      if (this.type === 'apply') {
        return this.invoice.date
      } else {
        return this.invoice.drewDate.length > 11 ? this.invoice.drewDate.slice(0, 10) : this.invoice.drewDate
      }
    },
    renderInvoiceType (text) {
      if (this.type === 'income') {
        return renderTextWithConfig(text, INVOICE_TYPE_FOR_CARD_INCOME)
      }
      return renderTextWithConfig(text, INVOICE_TYPE_FOR_CARD)
    },
    renderInvoiceMethod (text) {
      return renderTextWithConfig(text, INVOICE_METHOD)
    },
    renderGetType (text) {
      return renderTextWithConfig(String(text), GET_TYPE)
    },
    getConfig (item) {
      let key = ''
      if (item.status === 0 || item.status === 1) {
        if (item.applyReturnFlag === 1) {
          key = 'invoice-return'
        } else {
          key = 'invoice-uninvoice' // 未开具
        }
      }
      if (item.status === 2) { // 开具中
        key = 'invoicing'
      }
      // if (item.status === 1) {
      //   key = 'invoice-part' // 部分开具
      // }
      if (item.status === 3) {
        key = 'invoice-success' // 开具成功
      }
      if (item.status === 4) {
        key = 'invoice-failed' // 开具失败
      }
      if (item.status === 6) {
        key = 'part' // 部分开具
      }
      if (item.invoiceStatus === 10 || item.invoiceStatus === 15 || item.invoiceStatus === 25) { // 正常   15红冲中 25作废中 属于 正常状态
        if (item.amount < 0) {
          key = 'output-negative' // 销项负数
        } else {
          key = 'invoice-normal'
        }
      }
      if (item.invoiceStatus === 10 && item.applyType === 1) {
        key = 'to-be-red' // 待红冲
      }
      if (item.invoiceStatus === 10 && item.applyType === 2) {
        key = 'to-be-cancel' // 待作废
      }
      if (item.invoiceStatus === 20) { // 红冲
        key = 'invoice-red'
      }
      if (item.invoiceStatus === 30) { // 作废
        key = 'invoice-abandon'
      }
      if (item.invoiceStatus === 40) { // 失控
        key = 'invoice-out-of-control'
      }
      if (item.invoiceStatus === 50) { // 异常
        key = 'invoice-error'
      }
      // 审核中
      if (item.approvalStatus === 0) {
        key = 'under-approval'
      }
      // 已驳回
      if (item.approvalStatus === 1) {
        key = 'returned'
      }
      // 已撤销
      if (item.approvalStatus === 3) {
        key = 'revoked'
      }
      // 审核通过
      if (!key) {
        if (item.approvalStatus === 2) {
          key = 'approved'
        } else {
          return ''
        }
      }
      return getConfigWithText(key, INVOICE_STATUS_ICON)
    },
    findButton (text) {
      return invoiceCardButtonType.find(type => type.method === text)
    },
    none () {

    },
    isButtonDisabled (type) {
      return this.disabledBtnList.includes(type)
    },
    downloadLayout (invoice) {
      this.$emit('download-layout', invoice)
    },
    retry (invoice) {
      this.edit(invoice)
    },
    async settlementInvoicePreview (invoice) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      await this.getSettlementInvoice(invoice)
      Toast.clear()
      this.settlementInvoiceVisible = true
    },
    async detail (invoice) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      await this.getApplyDetail(invoice.agentSettlementId, true)
      await this.getDetails(invoice)
      Toast.clear()
      this.$router.push(`/invoice/info?look=1}`) // 跳转到没有按钮的详情页面
    },
    async applyDetail (invoice) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      await this.getApplyDetail(invoice.id, true)
      Toast.clear()
      const isEditable = invoice.status === 0 ||
        invoice.status === 1 ||
        (invoice.status === 2 && invoice.settlementSource !== BATCH_IMPORT_SETTLEMENT_SOURCE)
      if (isEditable) { // 未开具 展示编辑按钮
        // 未开具,并且被退回
        if (invoice.applyReturnFlag === 1) {
          this.$router.push('/invoice/applyinfo?btntype=editAndSubmit&comeFormDian=1') // 跳转到有修改并重新发起按钮的详情页面
        } else {
          this.$router.push('/invoice/applyinfo?btntype=edit&comeFormDian=1') // 跳转到有按钮的详情页面
        }
      } else if (invoice.status === 4) { // 开票失败 展示重新开票按钮
        // this.$router.push('/invoice/applyinfo?btntype=redraft') // 跳转到有按钮的详情页面
        this.$router.push('/invoice/info?comeFormDian=1') // 跳转到没有按钮的详情页面
      } else { // 剩下的是开票成功的，不展示按钮，也不做什么处理
        this.$router.push('/invoice/info?comeFormDian=1') // 跳转到没有按钮的详情页面
      }
    },
    async customApplyDetail (invoice) { // 电票直开详情查看
      await this.getApplyDetail(invoice.id, true)
      this.$router.push('/invoice/uninvoice/info?comeFormDian=1') // 跳转到没有按钮的详情页面
    },
    // this.$router.push('/invoice/applyinfo') // 跳转到有按钮的详情页面
    async edit (invoice) {
      await this.getApplyDetail(invoice.id, true)
      this.$router.push(`/invoice/add-apply?edit=${invoice.id}&comeFormDian=1&showGoods=1`)
    },
    delete (invoice) {
      this.deleteApplyDetail(invoice.id)
    },
    async preview (invoice) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      await this.getDetails(invoice)
      Toast.clear()
      this.invoiceVisible = true
    },
    async express (invoice) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      await this.getApplyDetail(invoice.agentSettlementId)
      await this.getDetails(invoice)
      Toast.clear()
      this.$router.push({
        path: '/invoice/express?comeFormDian=1',
        query: {
          invoiceId: invoice.id,
          receiverAddress: invoice.receiverAddress,
          logisticsNo: invoice.logisticsNo,
          mobile: invoice.logisticsMobile,
          shipperCode: invoice.shipperCode
        }
      })
    },
    todo (funName, invoice) {
      this[funName](invoice)
    },
    getApplyDetail (id, changeInfo) {
      return new Promise(async (resolve, reject) => {
        if (!id) {
          resolve(true)
          return
        }
        const data = await invoiceRequest.apply.getApplyDetail({
          id
        })
        if (data.success) {
          let money = 0
          data.result.details.forEach(element => {
            money = onCount.add(money, element.amountWithTax)
          })
          this.files = data.result.fileInfos ? data.result.fileInfos.map(file => {
            return {
              url: file.fileUrl,
              file: {
                name: file.fileName
              }
            }
          }) : []
          const res = {
            ...data.result,
            files: [...this.files],
            invoiceType: String(data.result.invoiceType),
            logisticsFlag: String(data.result.logisticsFlag),
            money: String(money)
          }
          this.receiverInfo = {
            receiverName: data.result.receiverName,
            receiverAddress: data.result.receiverAddress,
            receiverPhone: data.result.receiverPhone,
            receiverEmail: data.result.receiverEmail,
            logisticsFlag: String(data.result.logisticsFlag)
          }
          if (changeInfo) {
            this.$store.commit('invoice/changeApplyData', {
              formData: res
            })
          }
          const goodsList = data.result.details.map(goods => {
            return {
              ...goods,
              price: goods.unitPrice === 0 ? null : goods.unitPrice,
              quantity: goods.quantity === 0 ? null : goods.quantity
            }
          })
          if (changeInfo) {
            this.$store.commit('invoice/changeGoodsList', goodsList)
          }
        } else {
          this.$store.commit('invoice/initApplyData')
          Notify({ type: 'danger', message: data.message })
        }
        resolve(true)
      })
    },
    getDetails (invoice) {
      if (invoice.proxyFlag === 1) {
        return new Promise(async (resolve, reject) => {
          const data = await invoiceRequest.apply.preview({
            settlementId: invoice.settlementId
          })
          if (data.success) {
            let money = 0
            data.result.sellerInvoiceDetails = data.result.detailList
            data.result.sellerInvoiceDetails.forEach(element => {
              money = onCount.add(money, element.amountWithTax)
            })
            const res = {
              ...data.result,
              ...this.receiverInfo,
              files: [...this.files],
              invoiceType: String(data.result.invoiceType),
              money: money
            }
            this.$store.commit('invoice/changeApplyData', {
              formData: res
            })
            this.detailData = res
            const goodsList = data.result.sellerInvoiceDetails.map(goods => {
              return {
                ...goods,
                price: goods.unitPrice
              }
            })
            this.$store.commit('invoice/changeGoodsList', goodsList)
          } else {
            this.$store.commit('invoice/initApplyData')
            Notify({ type: 'danger', message: data.message })
          }
          resolve(true)
        })
      } else {
        return new Promise(async (resolve, reject) => {
          const data = await invoiceRequest.apply.getDetails({
            id: invoice.id
          })
          if (data.success) {
            let money = 0
            data.result.sellerInvoiceDetails.forEach(element => {
              money = onCount.add(money, element.amountWithTax)
            })
            const res = {
              ...data.result,
              ...this.receiverInfo,
              files: [...this.files],
              invoiceType: String(data.result.invoiceType),
              logisticsFlag: String(data.result.logisticsFlag || ''),
              money: money
            }
            this.$store.commit('invoice/changeApplyData', {
              formData: res
            })
            this.detailData = res
            const goodsList = data.result.sellerInvoiceDetails.map(goods => {
              return {
                ...goods,
                price: goods.unitPrice
              }
            })
            this.$store.commit('invoice/changeGoodsList', goodsList)
          } else {
            this.$store.commit('invoice/initApplyData')
            Notify({ type: 'danger', message: data.message })
          }
          resolve(true)
        })
      }
    },
    async deleteApplyDetail (id) {
      const data = await invoiceRequest.apply.delete({ id })
      if (data.success) {
        Notify({ type: 'success', message: '删除成功' })
        this.$router.go(0)
      } else {
        this.$store.commit('invoice/initApplyData')
        Notify({ type: 'danger', message: data.message })
      }
    },
    async getSettlementInvoice (invoice) {
      const data = await invoiceRequest.apply.getInvoiceList({ agentSettlementId: invoice.id })
      if (data.success) {
        data.result.forEach(v => {
          v.sellerInvoiceDetails = v.details
        })
        this.invoiceList = data.result || []
      }
    },
    more () {
      this.popupVisible = true
    },
    onInputChange ({ e, field }) {
      if (field === 'applyMsg') {
        this.modalParams.applyMsg = e
      }
    },
    renderClass (type) {
      if (type === 'more') {
        return 'btn-item-more'
      }
      return ''
    },
    canRed () {
      if (this.invoice.invoiceStatus === 20) {
        return false
      }
      let nowDate = new Date()
      let dt = new Date(this.invoice.drewDate)
      let isCurrentMonth = nowDate.getFullYear() === dt.getFullYear() && nowDate.getMonth() === dt.getMonth()
      if (Number(this.invoice.invoiceType) === 2 || Number(this.invoice.invoiceType) === 3 || Number(this.invoice.invoiceType) === 4 || Number(this.invoice.invoiceType) === 7 || Number(this.invoice.invoiceType) === 8 || Number(this.invoice.invoiceType) === 9 || Number(this.invoice.invoiceType) === 10) {
        return true
      } else if (Number(this.invoice.invoiceType) === 1) {
        if (isCurrentMonth) {
          return false
        } else {
          return true
        }
      }
      return false
    },
    cancel () {
      if (this.invoice.invoiceStatus === 30) {
        return false
      }
      let nowDate = new Date()
      let dt = new Date(this.invoice.drewDate)
      let isCurrentMonth = nowDate.getFullYear() === dt.getFullYear() && nowDate.getMonth() === dt.getMonth()
      if (Number(this.invoice.invoiceType) === 2) {
        return true
      } else if (Number(this.invoice.invoiceType) === 1) {
        if (isCurrentMonth) {
          return true
        }
      }
      return false
    },
    modalClick (type) {
      if (type === 'applyRed') {
        this.applyInvoice({ applyType: 1 })
      } else if (type === 'applyCancel') {
        this.applyInvoice({ applyType: 2 })
      }
    },
    async applyInvoice ({ applyType }) {
      let params = {
        applyType,
        applyMsg: this.modalParams.applyMsg,
        id: this.invoice.id
      }
      const data = await invoiceRequest.apply.applyRedOrCancel(params)
      if (data.success) {
        this.$router.go(0)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    [Popup.name]: Popup,
    InvoiceImagePreview,
    InvoiceSwiper,
    InputField
  }
}

</script>

<style lang="less" scoped src="./style.less"/>
